import { render, staticRenderFns } from "./PointContainer.vue?vue&type=template&id=5be7c0af&scoped=true"
import script from "./PointContainer.ts?vue&type=script&lang=ts&external"
export * from "./PointContainer.ts?vue&type=script&lang=ts&external"
import style0 from "./PointContainer.vue?vue&type=style&index=0&id=5be7c0af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7c0af",
  null
  
)

export default component.exports